import { render } from "./Widget7.vue?vue&type=template&id=72d24af2"
import script from "./Widget7.vue?vue&type=script&lang=ts"
export * from "./Widget7.vue?vue&type=script&lang=ts"
script.render = render

export default script